<template>
    <div>
        <div ref="chartdiv" :style="{ height: height, width: width }">
        </div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import { EventBus } from '../../event/event-bus.js';
    export default {
        inject: ['globalColourMap'],
        name: 'PieChart',
        props: {
            width: {
                default: "auto",
                type: String
            },
            height: {
                default: "350px",
                type: String
            },
            title: {
                default: "",
                type: String
            },
            data: {
                default: () => [],
                type: Array
            },
            fontSize: {
                default: 14,
                type: Number
            },
            opacity: {
                default: 100,
                type: Number
            },
            colors: {
                default: function () { return [] },
                type: Array
            },
            showDateRange: {
                default: true,
                type: Boolean
            },
            semiMode: {
                default: false,
                type: Boolean
            },
            showPercent: {
                default: true,
                type: Boolean
            }
        },
        watch: {
            deep: true,
            immediate: true,
            data() {
                this.render();
            },
            title(val) {
                this.titleObj.text = val;
                this.titleObj.fontSize = 20;
            },
            type() {
                this.render();
            },
            opacity(val) {
                this.seriesArr.forEach((series) => {
                    series.fillOpacity = val / 100;
                });
            },
            colors(val) {
                if (val && val.length > 1) {
                    let colorSet = new am4core.ColorSet();
                    colorSet.reuse = true;
                    colorSet.list = val.map((color) => { return am4core.color(color) });
                    this.pieSeries.colors = colorSet;
                    this.render();
                }
                else {
                    this.render();
                }
            },
        },
        data: function () {
            return {
                pieSeries: [],
                titleObj: {},
                chart: null,
            }
        },
        created() {
            EventBus.$on('emit-theme-change', () => {
                this.refreshTheme();
            });
        },
        mounted() {
            this.render();
        },
        methods: {
            async render() {
                this.seriesArr = [];

                if (!this.data || this.data.length === 0) {
                    this.dispose();
                    return;
                }

                this.chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart);
                this.chart.responsive.enabled = true;
                this.chart.paddingRight = 20;

                this.chart.fontSize = this.fontSize;

                this.titleObj = this.chart.titles.create();
                let titleText = this.showDateRange == true ? this.title : this.title.split(" - ")[0];
                titleText = `${titleText} - (${this.data.map(x => x.value).reduce((a, b) => a + b, 0)} total)`;
                titleText = titleText.replace("{count}", this.data.length);
                this.titleObj.text = titleText;
                this.titleObj.fontSize = 20;
                this.titleObj.marginBottom = 20;

                this.chart.data = this.data;

                this.chart.tooltip.label.maxWidth = 150;
                this.chart.tooltip.label.wrap = true;

                this.chart.radius = am4core.percent(65);

                if (this.semiMode) {
                    this.chart.radius = am4core.percent(70);
                    this.chart.innerRadius = am4core.percent(40);
                    this.chart.startAngle = 180;
                    this.chart.endAngle = 360;
                }

                // Add and configure Series
                this.pieSeries = this.chart.series.push(new am4charts.PieSeries());
                this.pieSeries.dataFields.value = "value";
                this.pieSeries.dataFields.category = "name";
                this.pieSeries.slices.template.stroke = am4core.color("#fff");
                this.pieSeries.slices.template.strokeOpacity = 1;
                this.pieSeries.slices.template.adapter.add("fill", function (fill, target) {
                    var i = this.globalColourMap.nameToInt(target.dataItem.category);
                    return this.pieSeries.colors.list[i];
                }.bind(this));
                if (!this.showPercent) {
                    this.pieSeries.slices.template.tooltipText = "{name}: {value.value}";
                    this.pieSeries.labels.template.text = "{name}: {value.value}";
                }

                //this.pieSeries.labels.template.maxWidth = 170;
                this.pieSeries.labels.template.fontSize = 9.5;
                // this.pieSeries.labels.template.wrap = true;
                this.pieSeries.labels.template.inside = true;
                this.pieSeries.labels.template.radius = 10;

                // This creates initial animation
                this.pieSeries.hiddenState.properties.opacity = 1;
                this.pieSeries.hiddenState.properties.endAngle = -90;
                this.pieSeries.hiddenState.properties.startAngle = -90;

                if (this.colors && this.colors.length > 1) {
                    let colorSet = new am4core.ColorSet();
                    colorSet.reuse = true;
                    colorSet.list = this.colors.map((color) => { return am4core.color(color) });

                    this.pieSeries.colors = colorSet;
                }
                else {
                    this.pieSeries.colors = new am4core.ColorSet();
                }

                this.chart.hiddenState.properties.radius = am4core.percent(0);
            },
            dispose() {
                if (this.chart) {
                    this.chart.dispose();
                }
            },
            async refreshTheme() {
                await this.render();
            }
        },
        beforeDestroy() {
            this.dispose();
        }
    }


</script>
